import React, { Fragment, useState, useContext } from 'react'
import { can } from '../../utils/can';

import { JobAppContext } from '../../GlobalState';
import { Collapse, Navbar, Nav } from 'reactstrap';
import { NavLink } from '../partials/NavLink';

import './TopNav.css';

/*
const getTitle = () => {
	const company = JSON.parse(localStorage.getItem('company'))
	if (company !== null) {
		return `${company.name}`
	}
	return 'Job Information'
}
*/

const TopNav = (props) => {

	const { isAuthenticated, user, signOut } = useContext(JobAppContext);
	
	const [ isOpen, setIsOpen ] = useState(false);

	/*
	const toggleNavbar = () => {
		setIsOpen(!isOpen);
	}
	*/
	return (
		<Navbar id="left-hand-nav" expand="sm" className="sidebar">
			{/*<NavbarToggler onClick={this.toggleNavbar} className="mr-2 mb-2" />*/}
			<Collapse isOpen={isOpen} navbar className="sidebar-sticky">
				<Nav className="navbar-top nav-links" navbar vertical>
				{isAuthenticated && (
					<Fragment>
						<NavLink to="/jobs" highlight="jobs">
							<span className="fa fa-list" /><span className="d-xs-inline d-sm-none d-xl-inline"> Jobs</span>
						</NavLink>
				
						<NavLink to="/forms" highlight="forms">
							<span className="fa fa-columns" /><span className="d-xs-inline d-sm-none d-xl-inline"> Forms</span>
						</NavLink>

						{can(['users'], user) && (
							<NavLink to="/users" highlight="users">
							<span className="fa fa-users" /><span className="d-xs-inline d-sm-none d-xl-inline"> Users</span>
							</NavLink>
						)}

						<NavLink to="/settings" highlight="settings" classes="d-block d-sm-none">
							<span className="fa fa-cog" /><span> Settings</span>
						</NavLink>

						<li className="NavLink d-block d-sm-none">
							<a href="/" className="nav-link subtle" onClick={() => signOut()}>
								<span className="fas fa-sign-out-alt" /><span> Logout</span>
							</a>
						</li>
					</Fragment>
				)}
				</Nav>

				{isAuthenticated && (
					<ul className="navbar-nav flex-column nav-links nav-bottom d-none d-sm-block">
						<NavLink to="/settings" highlight="settings">
							<span className="fa fa-cog" /><span className="d-none d-xl-inline"> Settings</span>
						</NavLink>
						<li className="NavLink">
							<a href="/" className="nav-link subtle" onClick={() => signOut()}>
								<span className="fas fa-sign-out-alt" /><span className="d-none d-xl-inline"> Logout</span>
							</a>
						</li>
					</ul>
				)}
			</Collapse>
		</Navbar>
	)
}
export default TopNav;
